import { render, staticRenderFns } from "./PlatformDetailPage.vue?vue&type=template&id=7f9e5dd0&scoped=true"
import script from "./PlatformDetailPage.vue?vue&type=script&lang=js"
export * from "./PlatformDetailPage.vue?vue&type=script&lang=js"
import style0 from "./PlatformDetailPage.vue?vue&type=style&index=0&id=7f9e5dd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9e5dd0",
  null
  
)

export default component.exports